import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import BursaAPIStbCert from './bursa-api-stb-cert';
import BursaAPIStbCertDetail from './bursa-api-stb-cert-detail';
import BursaAPIStbCertUpdate from './bursa-api-stb-cert-update';
import BursaAPIStbCertDeleteDialog from './bursa-api-stb-cert-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={BursaAPIStbCertUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={BursaAPIStbCertUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={BursaAPIStbCertDetail} />
      <ErrorBoundaryRoute path={match.url} component={BursaAPIStbCert} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={BursaAPIStbCertDeleteDialog} />
  </>
);

export default Routes;
